import { Component } from '@angular/core';


export class FishModalBackdrop {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'fish-modal-backdrop',
    template: '',
    host: { 'class': 'modal-backdrop fade show' }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
